export const InitialFeedbackData = {
  payload: {
    name: "",
    email: "",
    subject: "",
    body: "",
  },
};
